<span
	*ngIf="status == 'cancelled'"
	class="freud-icon freud-icon-circle-x"
>
</span>
<span *ngIf="status == 'invite'" class="freud-icon freud-icon-send">
</span>
<fa-icon *ngIf="status == 'new'" icon="asterisk"></fa-icon>
<span *ngIf="status == 'paid'" class="freud-icon freud-icon-circle-check">
</span>
<span
	*ngIf="status == 'reschedule'"
	class="freud-icon freud-icon-calendar-time"
>
</span>
<span
	*ngIf="status == 'reserved'"
	class="freud-icon freud-icon-circle-clock"
>
</span>
<span
	*ngIf="status == 'reschedule_request' && !userRequestedReschedule"
	class="freud-icon freud-icon-send"
>
</span>
<span
	*ngIf="status == 'reschedule_request' && userRequestedReschedule"
	class="freud-icon freud-icon-send"
>
</span>
